var MethodMaterialMode = (function () {
    function MethodMaterialMode() {
    }
    return MethodMaterialMode;
}());
export { MethodMaterialMode };
/**
 *
 */
MethodMaterialMode.SINGLE_PASS = "singlePass";
/**
 *
 */
MethodMaterialMode.MULTI_PASS = "multiPass";



// WEBPACK FOOTER //
// ../dist/lib/MethodMaterialMode.js